module.exports = __webpack_public_path__ + "img/hawaii.cf93fce4.svg";